import lnaBaseLayout from './lna-base-layout'
import seaBaseLayout from './sea-base-layout'
import thirdJobActLayout from './third-job-act-layout'
import '@/pages/sea/static/lib/joymaker-jssdk.min'

const seaRoute = ['/reservation/sakura2024']

const thirdJobActRoute = ['/third-job-act', '/m/third-job-act']

export default seaRoute.includes(location.pathname)
  ? seaBaseLayout
  : thirdJobActRoute.includes(location.pathname)
  ? thirdJobActLayout
  : lnaBaseLayout
